import { render, staticRenderFns } from "./CustomerBepokePriceTiersPopUp.vue?vue&type=template&id=453d9621&scoped=true&"
import script from "./CustomerBepokePriceTiersPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerBepokePriceTiersPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBepokePriceTiersPopUp.vue?vue&type=style&index=0&id=453d9621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d9621",
  null
  
)

export default component.exports